import React, { useContext, useEffect, useRef } from 'react'
import { Context } from '../context/context';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import Navbar from '../components/Navbar';
import founderImg from '../images/Founder.png';
import lagacyImg from '../images/Legacy.png';
import masterImg from '../images/Master.png';
import FeaturesSection from '../components/FeaturesSection';
import xImg from '../images/twitter.png';
import teleImg from '../images/telegram.png';
import blockstarImg from '../images/blockstar.png';


export default function Home() {
  let { setProgress } = useContext(Context);
  const queryParams = new URLSearchParams(window.location.search);
  const code = queryParams.get('code');
  const count = useRef(0);
  const history = useHistory();


  useEffect(() => {
    async function fetch() {
      if (code && count.current === 0) {
        count.current = count.current + 1;
        const formData = new FormData();
        formData.append('token', code);
        const response = await axios.post('https://blockstar.center/api/blockstar-login.php', formData);
        if (response && response.data && response.data.status === 'success') {
          localStorage.setItem("blockstardao", response.data.data.token)
          localStorage.setItem("blockstardao_username", response.data.data.data.email)
          history.push('/dashboard')

        }
        else {
          toast.error(response.data.message)

        }
      }

      setProgress(100);
    }

    fetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code])

  return (
    <>
      <Navbar />
      <div className="container mt-5">
        <div className="text-center mx-auto" style={{ maxWidth: "1100px" }}>
          <h4 className="display-5 mb-5 hero-title">
            <span className="text-white">
            A <span className='text-primary'>Legacy</span> In The <span className='text-primary'>Making</span></span>
          </h4>
          {/* <p className="lead text-light mb-5">
            Sun Heading
          </p> */}
          <div class="row row-cols-1 row-cols-md-4 g-3 d-flex justify-content-center">
            <div class="col">
              <div class="card nft-card">
                <img src={founderImg} className='nft-img' alt='nft' />
                <div class="card-body">
                  <h5 class="card-title">Qty: 50</h5>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card nft-card">
                <img src={masterImg} className='nft-img' alt='nft' />
                <div class="card-body">
                  <h5 class="card-title">Qty: 250</h5>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card nft-card">
                <img src={lagacyImg} className='nft-img' alt='nft' />
                <div class="card-body">
                  <h5 class="card-title">Qty: 500</h5>
                </div>
              </div>
            </div>
          </div>
          <FeaturesSection />
        </div>
      </div >

      <div class="container">
        <div class="row text-center">
          <div class="col-md-6 mb-3 mb-md-0">
            <span class="copyright quick-links">
              blockstar.site &copy; {new Date().getFullYear()} All rights reserved
            </span>
          </div>
          <div class="col-md-6">
            <ul class="list-inline social-buttons">
              <li class="list-inline-item">
                <a href="https://x.com/BlockStar_BST" className="text-white me-3" target="_blank" title="Twitter">
                  <img src={xImg} alt='x' height="25px" width="25px" />
                </a>
              </li>
              <li class="list-inline-item">
                <a href="https://t.me/BlockStar_Announcements" className="text-white me-3" target="_blank" title="Instagram">
                  <img src={teleImg} alt='x' height="30px" width="30px" />
                </a>
              </li>
              <li class="list-inline-item">
                <a href="https://blockstar.social/BlockStar" className="text-white" target="_blank" title="LinkedIn">
                  <img src={blockstarImg} alt='x' height="30px" width="30px" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </>
  )
}
